import { render, staticRenderFns } from "./TabOptionalExperience.vue?vue&type=template&id=a94a0230&"
import script from "./TabOptionalExperience.vue?vue&type=script&lang=js&"
export * from "./TabOptionalExperience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports